export const environment = {
  production: true,
  BASE_DOMAIN:'https://jawa.apollosupplychain.com/',
  New_BASE_DOMAIN:'https://jawa.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://jawa.apollosupplychain.com/',
  WebsocketUrl: 'wss://jawa.apollosupplychain.com/websocket-service/ws/notifications'
};
